export default __webpack_public_path__ + "static/media/blog1_5.9bee5860.png";